import imglogo from "../../img/mainLogoWhite.png";
import textlogo from "../../img/mainWriters.png";
import "./index.css";

export function Preloader() {
  return (
    <div className="preloader">
      <img src={imglogo} className="preloaderImg" alt=""/>
      <img src={textlogo} className="preloaderText" alt=""/>
    </div>
  );
}
